export default __webpack_public_path__ + "static/media/GUNS-BNB.29f459ca.png";